import { selectUserOrgByApp } from '@rsos/sinatra';
import { postIssue } from '../../services/capstone';
import {
  CREATE_ISSUE_START,
  CREATE_ISSUE_SUCCESS,
  CREATE_ISSUE_FAILED,
} from '../actionTypes';

export const createIssueStart = () => ({
  type: CREATE_ISSUE_START,
});

export const createIssueSuccess = issue => ({
  type: CREATE_ISSUE_SUCCESS,
  issue,
});

export const createIssueFailed = error => ({
  type: CREATE_ISSUE_FAILED,
  error,
});

/**
 * Creates a help desk issue to start the shapefile approval process via the
 * Capstone API for the current PSAP.
 *
 * @param {FormData} shapefileContents - A binary string for the shapefile
 * contents which can be a zip file or standalone files like geojson, KML, etc..
 */
const createIssue = shapefileContents => (dispatch, getState) => {
  const { sinatra } = getState();
  const application = sinatra.user.currentRole.application;
  const org = selectUserOrgByApp(sinatra, application);
  dispatch(createIssueStart());
  return postIssue(shapefileContents, org.name)
    .then(issue => {
      return dispatch(createIssueSuccess(issue));
    })
    .catch(error => {
      throw dispatch(createIssueFailed(error));
    });
};

export default createIssue;
